/*
 *
 * RootModal reducer
 *
 */

import {
  CLEAR_MODAL,
  SET_MODAL,
} from './constants';

const initialState = {
  modalType: '',
  modalProps: {},
};

function rootModalReducer(state = initialState, action) {
  switch (action.type) {
    case CLEAR_MODAL:
      return initialState;
    case SET_MODAL:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}

export default rootModalReducer;



// WEBPACK FOOTER //
// ./src/containers/RootModal/reducer.js